import { c as _c } from "react/compiler-runtime";
import { H2 } from '@algoacademy/design-system/web/typography/Heading';
import { TechnologyCard } from './TechnologyCard';
type TechnologiesProps = {
  technologies: {
    name: string;
    urlIcon?: string;
  }[];
};
export function Technologies(t0) {
  const $ = _c(2);
  const {
    technologies
  } = t0;
  let t1;
  if ($[0] !== technologies) {
    t1 = technologies.length > 0 && <div className="flex flex-col items-center gap-6"><H2>Technologie, których nauczam</H2><div className="flex flex-row flex-wrap justify-center gap-4">{technologies.map(_temp)}</div></div>;
    $[0] = technologies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(technology) {
  return <TechnologyCard key={technology.name} technology={technology} />;
}